// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--post-office-team/rovo-nudge';

import { MessageFrontend as createMessageFrontendLiveNudgeDemoMessage } from '@post-office/browser--post-office-team/live-nudge-demo-message/placements/in-app-v2/rovo-nudge';
import { MessageFrontend as createMessageFrontendLiveAndPersistedTestMessage } from '@post-office/browser--post-office-team/live-and-persisted-test-message/placements/in-app-v2/rovo-nudge';
import { MessageFrontend as createMessageFrontendJiraBoardCatchUpRovoNudge } from '@post-office/browser--growth/jira-board-catch-up-rovo-nudge/placements/in-app-v2/rovo-nudge';
import { MessageFrontend as createMessageFrontendJiraBoardBacklogUpdateWorkSuggestions } from '@post-office/browser--jira-pulsar/jira-board-backlog-update-work-suggestions/placements/in-app-v2/rovo-nudge';
import { MessageFrontend as createMessageFrontendJiraWorkItemCatchupParent } from '@post-office/browser--rovo-chat/jira-work-item-catchup-parent/placements/in-app-v2/rovo-nudge';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type ComponentType, type ComponentProps } from 'react';

const messageFrontends = [
	createMessageFrontendLiveNudgeDemoMessage({ messageTemplateId: 'live-nudge-demo-message' }),
	createMessageFrontendLiveAndPersistedTestMessage({
		messageTemplateId: 'live-and-persisted-test-message',
	}),
	createMessageFrontendJiraBoardCatchUpRovoNudge({
		messageTemplateId: 'jira-board-catch-up-rovo-nudge',
	}),
	createMessageFrontendJiraBoardBacklogUpdateWorkSuggestions({
		messageTemplateId: 'jira-board-backlog-update-work-suggestions',
	}),
	createMessageFrontendJiraWorkItemCatchupParent({
		messageTemplateId: 'jira-work-item-catchup-parent',
	}),
];

export const RawPlacement: ReturnType<typeof PlacementFrontend.createPlacementFrontendComponent> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

type GeneratedPlacementProps = ComponentProps<typeof RawPlacement>;

export const Placement: ComponentType<
	Omit<GeneratedPlacementProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<GeneratedPlacementProps> = RawPlacement;
